export default {
  name: 'marking--conformityCertificateUpload',
  apiService: 'shoes',
  apiPath: '/admin/conformity_certificate/upload',
  urlParamName: 'marking--conformityCertificateUpload',
};